const topmenuTriggers = document.querySelectorAll('.topmenu__toggle')

if (topmenuTriggers.length) {
  const topMenuActiveClass = 'topmenu__submenu--active'

  topmenuTriggers.forEach((item) => {
    item.addEventListener('click', () => {
      const nextElement = item.nextElementSibling

      if (nextElement.classList.contains(topMenuActiveClass)) {
        nextElement.classList.remove(topMenuActiveClass)
        return
      }

      const allActive = document.querySelectorAll(`.${topMenuActiveClass}`)
      allActive.forEach((item) => {
        item.classList.remove(topMenuActiveClass)
      })

      if (nextElement.classList.contains('topmenu__submenu')) {
        nextElement.classList.toggle(topMenuActiveClass)
      }
    })
  })

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.navigation')) {
      const allActive = document.querySelectorAll(`.${topMenuActiveClass}`)
      allActive.forEach((item) => {
        item.classList.remove(topMenuActiveClass)
      })
    }
  })
}
